<template>
  <div>
    <HighChart :options="chartOptions" />
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'

export default {
  name: 'AlarmPlot',
  components: {
    HighChart: Chart
  },
  props: {
    samples: {
      type: Array,
      required: false
    },
    color: {
      type: String,
      required: false
    },
    direction: {
      type: Boolean,
      required: false
    },
    sampleInterval: {
      type: Number,
      required: false
    },
    unitOfMeasure: {
      type: String,
      required: false
    },
    areaRangeData: {
      type: Array,
      required: false
    },
    title: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      loading: false,
      chartOptions: this.getChartOptions(this)
    }
  },
  computed: {

  },
  mounted: async function () {
  },
  methods: {
    getChartOptions (t) {
      return {
        chart: {
          height: '180px',
          zoomType: 'xy',
          type: 'line',
          animation: false,
          zooming: {
            mouseWheel: {
              enabled: true
            }
          },
          events: {
            load () {
              const chart = this

              // Block scroll wheel unless Shift is held
              chart._wheelBlocker = (e) => {
                if (!e.shiftKey) {
                  if (e.stopImmediatePropagation) e.stopImmediatePropagation()
                  e.stopPropagation()
                }
              }
              chart.container.addEventListener('wheel', chart._wheelBlocker, { capture: true })

              // Show zoom cursor when Shift is held
              chart._cursorHint = (e) => {
                chart.container.style.cursor = e.shiftKey ? 'zoom-in' : ''
              }
              chart.container.addEventListener('mousemove', chart._cursorHint)

              // Flip cursor immediately on Shift press/release
              chart._onKeyShift = (e) => {
                if (e.key === 'Shift' && chart.container) {
                  chart.container.style.cursor = (e.type === 'keydown') ? 'zoom-in' : ''
                }
              }
              chart._offKeyDown = Highcharts.addEvent(document, 'keydown', chart._onKeyShift)
              chart._offKeyUp = Highcharts.addEvent(document, 'keyup', chart._onKeyShift)
            },
            destroy () {
              const el = this.container
              if (this._wheelBlocker && el) el.removeEventListener('wheel', this._wheelBlocker, { capture: true })
              if (this._cursorHint && el) el.removeEventListener('mousemove', this._cursorHint)
              if (this._offKeyDown) this._offKeyDown()
              if (this._offKeyUp) this._offKeyUp()
            }
          }
        },

        accessibility: {
          enabled: false
        },

        credits: {
          enabled: false
        },

        title: {
          text: ''
        },

        subtitle: {
          text: this.title
        },

        legend: {
          enabled: false
        },

        plotOptions: {
          line: {
            marker: {
              enabled: false,
              animation: false
            },
            color: this.color
          }
        },

        tooltip: {
          formatter: function () {
            return '<b>' + this.x.toFixed(2) + ' s</b><br/>' +
              t.$t('views.switch.alarmsettings.value') + ': ' + this.y.toFixed(2) + ' ' + t.unitOfMeasure + '<br/>' +
              t.$t('views.switch.alarmsettings.direction') + ': ' +
              (!this.direction ? t.$t('views.switch.alarmsettings.normal') : t.$t('views.switch.alarmsettings.reverse'))
          }
        },

        lang: {
          noData: this.$t('views.switch.nodata'),
          viewFullscreen: this.$t('charts.exporting.fullscreen'),
          printChart: this.$t('charts.exporting.printchart'),
          downloadPNG: this.$t('charts.exporting.downloadpng'),
          downloadJPEG: this.$t('charts.exporting.downloadjpeg'),
          downloadPDF: this.$t('charts.exporting.downloadpdf'),
          downloadSVG: this.$t('charts.exporting.downloadsvg'),
          downloadCSV: this.$t('charts.exporting.downloadcsv'),
          downloadXLS: this.$t('charts.exporting.downloadxls'),
          viewData: this.$t('charts.exporting.viewdatatable'),
          hideData: this.$t('charts.exporting.hidedatatable')
        },

        xAxis: {
          title: {
            enabled: true,
            text: this.$t('views.switch.alarmsettings.time') + ' (s)'
          }
        },

        yAxis: {
          title: {
            text: '[' + this.unitOfMeasure + ']'
          }
        },

        series: [
          {
            name: this.$t('views.switch.alarmsettings.current'),
            data: []
          },
          {
            name: 'Reference Range',
            data: this.areaRangeData,
            type: 'arearange',
            color: 'rgba(100, 100, 255, 0.2)',
            fillOpacity: 0.3,
            lineWidth: 0,
            marker: {
              enabled: false
            },
            tooltip: {
              pointFormat: 'Low: {point.low}<br/>High: {point.high}<br/>'
            }
          }
        ]
      }
    },

    updateChart () {
      this.chartOptions = { ...this.chartOptions }
    }
  },
  watch: {
    samples (newData) {
      this.chartOptions.series[0].data = newData
    },
    color (newColor) {
      this.chartOptions.plotOptions.line.color = newColor
      this.updateChart()
    },
    areaRangeData (newData) {
      this.chartOptions.series[1].data = newData
      this.chartOptions.series[1].color = this.color
      this.updateChart()
    },
    title (newTitle) {
      this.chartOptions.subtitle.text = newTitle
      this.updateChart()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/switch/AlarmPlot.vue